export default __webpack_public_path__ + "static/media/ipadiphone-new.dfd53617.png";